import angular from "angular";
import template from "./student-metadata.html";
import controller from "./student-metadata.controller";

function getStudentMetaDataPolicy(PoliciesStoreService) {
  const storePolicy = PoliciesStoreService.getPolicy("studentmetadata");
  const policy = {
    id: 0,
    studentmetadata: {
      preferred_pronoun: false,
    },
  };
  if (storePolicy) {
    policy.id = storePolicy.id;
    policy.studentmetadata = {
      preferred_pronoun: storePolicy.policymeta.preferred_pronoun,
    };
  }
  return policy;
}
getStudentMetaDataPolicy.$inject = ["PoliciesStoreService"];

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.settings.policies.studentmetadata", {
    url: "/student-metadata",
    controller: controller,
    controllerAs: "vm",
    template: template,
    resolve: {
      studentmetadata: getStudentMetaDataPolicy,
    },
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.owner,
        USER_ROLES.administrator,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.settings.policies.studentmetadata", [])
  .config(config)
  .controller("AdminSettingsPoliciesStudentMetaDataController", controller);
